import * as log from 'loglevel'
import remote from './loglevel-custom-remote'
import prefix from 'loglevel-plugin-prefix'

// To clean the loglevel-plugin-prefix line in the stack-trace:
// options = { depth: 1 }

const defaults = {
    url: 'https://hippocampus.medisin.ntnu.no/api/memorolog.php', // 'https://listener.logz.io:8071/?token=OtLfGOMRVCTQgIUFXTDJSTUVnIVqonLI',
    timeout: 0,
    interval: 100,
    backoff: (interval) => {
        const multiplier = 2
        const jitter = 0.1
        const limit = 30000
        let next = interval * multiplier
        if (next > limit) next = limit
        next += next * jitter * Math.random()
        return next
    },
    capacity: 0,
    trace: ['trace', 'warn', 'error'],
    depth: 0,
    json: false,
    timestamp: () => new Date().toISOString(),
}

var prefixDefaults = {
    template: '[%t]:',
    timestampFormatter: function (date) {
        return date.toTimeString().replace(/.*(\d{2}:\d{2}:\d{2}).*/, '$1')
    },
    levelFormatter: function (level) {
        return level.toUpperCase()
    },
    nameFormatter: function (name) {
        return name || 'root'
    },
}

if (process.env.NODE_ENV === 'development') {
    log.setLevel('TRACE', true)
    log.enableAll()
} else {
    // We might want to log somewhere else in production (eg logger
    // service via http etc)
    remote.apply(log, defaults)
    prefix.apply(log, prefixDefaults)
    log.setLevel('ERROR', true)
}
export default log



// WEBPACK FOOTER //
// ./src/lib/logger.js